// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingDots_root__TQ2dz","blink":"LoadingDots_blink__hdoF6"};